import { classes } from "portal/theme/theme";
import { FacilityType } from "portal/utils/geo";
import HQIcon from "@mui/icons-material/StarOutlined";
import React, { FunctionComponent } from "react";
import ShopIcon from "@mui/icons-material/FactoryOutlined";

interface Props {
  className?: string;
  facilityType: FacilityType;
}
export const FacilityTypeIcon: FunctionComponent<Props> = ({
  className = "text-base",
  facilityType,
}) => {
  const baseClass = "h-4 w-4";
  switch (facilityType) {
    case FacilityType.HQ: {
      return <HQIcon className={classes(baseClass, className)} />;
    }
    case FacilityType.SHOP: {
      return <ShopIcon className={classes(baseClass, className)} />;
    }
    default: {
      return <HQIcon className={classes(baseClass, className)} />;
    }
  }
};
